import {useQuery} from '@tanstack/react-query';

import {getEvent} from '../api';
import {QUERY__EVENT} from '../queryKeys';
import {Event} from '../types';

import {QueryOptionsForOne} from '@/shared/api';

export const useGetEvent = <SelectedData = Event>(
  event_id: string,
  options?: QueryOptionsForOne<Event, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__EVENT, event_id],
    queryFn: () => getEvent(event_id),
    ...options,
  });
};
